// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./ToggleTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toggle-module__Container__FDpAx {
    display: flex;
    gap: var(--ds-4x);
    align-items: center;
    border-radius: var(--ds-border-radius-s);
    cursor: pointer;
}

.Toggle-module__Container__FDpAx:focus-visible {
    outline: var(--ds-05x) solid var(--ds-toggle-container-outline-color);
    outline-offset: var(--ds-primary-button-outline-offset);
}

.Toggle-module__Toggle__taZ3c {
    display: flex;
    align-items: center;
    width: var(--ds-14x);
    height: var(--ds-8x);
    padding: var(--ds-05x);
    border-style: solid;
    border-width: var(--ds-border-width-focus);
    border-radius: var(--ds-border-radius-m);
    transition: var(--ds-transition-s) ease-in-out;
}

.Toggle-module__ToggleBig__hAnus {
    width: var(--ds-14x);
    height: var(--ds-8x);
}

.Toggle-module__ToggleSmall__IsSL8 {
    width: var(--ds-10x);
    height: var(--ds-6x);
}

.Toggle-module__ToggleColor__BItOY {
    color: var(--ds-toggle-font-color);
}

.Toggle-module__ToggleDisabledColor__XcbPg {
    color: var(--ds-toggle-disabled-font-color);
}

.Toggle-module__ToggleON__oXKdy {
    background-color: var(--ds-toggle-on-bg-color);
    border-color: var(--ds-toggle-on-border-color);
}

.Toggle-module__ToggleONDisabled__yh04T {
    background-color: var(--ds-toggle-on-disabled-bg-color);
    border-color: var(--ds-toggle-on-disabled-border-color);
    cursor: default;
}

.Toggle-module__ToggleOFF__jtYpO {
    background-color: var(--ds-toggle-off-bg-color);
    border-color: var(--ds-toggle-off-border-color);
}

.Toggle-module__ToggleOFFDisabled__yduil {
    background-color: var(--ds-toggle-off-disabled-bg-color);
    border-color: var(--ds-toggle-off-disabled-border-color);
    cursor: default;
}

.Toggle-module__ToggleInProgress__ms7CO {
    justify-content: center;
    background-color: var(--ds-toggle-in-progress-bg-color);
    border-color: var(--ds-toggle-in-progress-border-color);
}

.Toggle-module__Circle__OcM0q {
    position: relative;
    left: 0;
    border-radius: var(--ds-border-radius-circle);
    transition: var(--ds-transition-s) ease-in-out;
}

.Toggle-module__CircleBig__KhsJW {
    width: var(--ds-6x);
    height: var(--ds-6x);
}

.Toggle-module__CircleSmall__iXJVd {
    width: var(--ds-4x);
    height: var(--ds-4x);
}

.Toggle-module__CircleON__vmvSk {
    background-color: var(--ds-toggle-on-circle-bg-color);
    box-shadow: 0 var(--ds-1x) var(--ds-2x) var(--ds-toggle-on-shadow-color);
}

.Toggle-module__CircleONDisabled__L24l3 {
    background-color: var(--ds-toggle-on-disabled-circle-bg-color);
}

.Toggle-module__CircleONBig__dWSqL {
    left: calc(100% - var(--ds-6x));
}

.Toggle-module__CircleONSmall__Tpm9Z {
    left: calc(100% - var(--ds-4x));
}

.Toggle-module__CircleOFF__QE8Cw {
    background-color: var(--ds-toggle-off-circle-bg-color);
}

.Toggle-module__CircleOFFDisabled__LzCGy {
    background-color: var(--ds-toggle-off-disabled-circle-bg-color);
}

.Toggle-module__CircleInProgress__ylIsg {
    display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Toggle-module__Container__FDpAx`,
	"Toggle": `Toggle-module__Toggle__taZ3c`,
	"ToggleBig": `Toggle-module__ToggleBig__hAnus`,
	"ToggleSmall": `Toggle-module__ToggleSmall__IsSL8`,
	"ToggleColor": `Toggle-module__ToggleColor__BItOY`,
	"ToggleDisabledColor": `Toggle-module__ToggleDisabledColor__XcbPg`,
	"ToggleON": `Toggle-module__ToggleON__oXKdy`,
	"ToggleONDisabled": `Toggle-module__ToggleONDisabled__yh04T`,
	"ToggleOFF": `Toggle-module__ToggleOFF__jtYpO`,
	"ToggleOFFDisabled": `Toggle-module__ToggleOFFDisabled__yduil`,
	"ToggleInProgress": `Toggle-module__ToggleInProgress__ms7CO`,
	"Circle": `Toggle-module__Circle__OcM0q`,
	"CircleBig": `Toggle-module__CircleBig__KhsJW`,
	"CircleSmall": `Toggle-module__CircleSmall__iXJVd`,
	"CircleON": `Toggle-module__CircleON__vmvSk`,
	"CircleONDisabled": `Toggle-module__CircleONDisabled__L24l3`,
	"CircleONBig": `Toggle-module__CircleONBig__dWSqL`,
	"CircleONSmall": `Toggle-module__CircleONSmall__Tpm9Z`,
	"CircleOFF": `Toggle-module__CircleOFF__QE8Cw`,
	"CircleOFFDisabled": `Toggle-module__CircleOFFDisabled__LzCGy`,
	"CircleInProgress": `Toggle-module__CircleInProgress__ylIsg`
};
export default ___CSS_LOADER_EXPORT___;
